import { render, staticRenderFns } from "./BuyBoxFilterNew.vue?vue&type=template&id=daa02e9a&scoped=true"
import script from "./BuyBoxFilterNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxFilterNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxFilterNew.vue?vue&type=style&index=0&id=daa02e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa02e9a",
  null
  
)

export default component.exports